<template>
  <a class="back-btn" href="#" @click.prevent="handleBack"><i class="fas fa-arrow-left"></i> Back </a>
</template>

<script>
export default {
  methods: {
    handleBack() {
      this.$emit('goBack')
    }
  }
}
</script>

<style lang="scss" scoped>

.back-btn {
    padding: .75rem 2.5rem;
    border-radius: 5px;
    display: inline-block;
    background-color: hsl(0, 0%, 100%);
    box-shadow: 0 2px 6px rgba($color: #000000, $alpha: .07);
    color: inherit;
    text-decoration: none;
    cursor: default;
    @media (min-width: 48em) {
        cursor: pointer;
    }
    .fas { 
        transform: translateX(-50%);
        transition: transform 200ms ease-out;
    }
    &:hover {
      .fas { transform: translateX(-100%) }
    }
}
</style>